import { createSlice } from '@reduxjs/toolkit';
import { ThunkGetVerificationSettings } from 'store/verificationSettings/thunks';
import { IVerificationSettings } from 'services/verificationSettings/types';
import { RootState } from 'store/index';

const initialState: Partial<{ settings: IVerificationSettings }> = {};

const verificationSettingsSlice = createSlice({
  name: 'verificationSettings',
  reducers: {},
  initialState,
  extraReducers: builder => {
    builder.addCase(ThunkGetVerificationSettings.fulfilled, (state, action) => {
      state.settings = action.payload;
    });
  },
});

export default verificationSettingsSlice.reducer;

export const VerificationSettingsSelector = (state: RootState): IVerificationSettings | undefined =>
  state.verificationSettings.settings;
